// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify'

export default createVuetify({
  defaults: {
    VBtn: {
      rounded: 'pill',
      style: 'text-transform: none; font-weight: 600;',
    },
    VChip: {
      rounded: 'pill',
    },
    VCard: {
      rounded: 'md',
    },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#2169A8',
          secondary: '#132540',
          background: '#fdfcf8',
          surface: '#ffffff',
          'surface-variant': '#f7f4ec',
          'on-primary': '#ffffff',
          'on-surface': '#0d1e35',
          info: '#4D9DDF',
          success: '#1AACB0',
          warning: '#e9a84a',
          error: '#b42318',
          'brand-ink': '#0d1e35',
          'brand-ocean': '#2169A8',
          'brand-teal': '#1AACB0',
          'brand-sand': '#f7f4ec',
          'status-strong-bg': '#daeefa',
          'status-weak-bg': '#fde8e8',
        }
      },
    },
  },
})
